import React, { useState } from "react";
import { Fields } from "uicomponents";
import { Field } from "formik";
import config from "config";
import EntityForm from "modules/entity/forms";
import get from "lodash/get";
import { ReactComponent as DeleteIcon } from "../../../assets/images/icons/trash.svg?react";
import { useDispatch } from "react-redux";
import Actions from "modules/entity/actions";
import useAlert from "../../../hooks/useAlert";
import useTranslation from "../../../hooks/useTranslation";
import { helpers } from "../../../services";

const ConsumptionHFPModal = ({ showConsumptionModalHFP, setCanUpdate }) => {
	const { tr } = useTranslation();

	const { showAlert } = useAlert();
	const dispatch = useDispatch();
	const [items, setItems] = useState([]);
	const [isSubmitting, setSubmitting] = useState(false);

	const deleteAction = item => {
		setItems(prev => prev.filter(p => p.product.id !== item.product.id));
	};

	const submitHandler = values => {
		const ref_storage_id = get(values, "ref_product_storage_id.id");
		const storage_id = get(values, "storage_id.id");
		const product = values.product_id;
		const quantity = values.quantity;

		setSubmitting(true);
		dispatch(
			Actions.FormDefault.request({
				method: "post",
				url: "/consumptions",
				values: {
					data: items.reduce(
						(prev, curr) => [
							...prev,
							{
								storage_id: storage_id,
								product_id: curr.product.id,
								quantity: curr.quantity
							}
						],
						[]
					),
					ref_product_id: product.id,
					ref_product_storage_id: ref_storage_id,
					ref_product_quantity: quantity,
					type: 2
				},
				cb: {
					success: () => {
						showConsumptionModalHFP(false);
						setCanUpdate(prev => !prev);
					},
					error: response => {
						showAlert(get(response, "errorMessage", ""), { type: "danger" });
					},
					finally: () => {
						setSubmitting(false);
					}
				}
			})
		);
	};
	return (
		<div className="">
			<div className="modal-title">{tr("Добавить расход")}</div>
			<div className="modal-body pos-relative">
				<EntityForm.Default
					method="post"
					url="/"
					fields={[
						{
							name: "required",
							required: true
						},
						{
							name: "type",
							value: config.CATEGORY_HALF_FINISHED
						},
						{
							name: "product_id",
							onSubmitValue: value => value.id
						},
						{
							name: "storage_id",
							onSubmitValue: value => value.id
						},
						{
							name: "ref_product_storage_id",
							onSubmitValue: value => value.id
						},
						{
							name: "quantity",
							value: ""
						}
					]}
				>
					{({ values }) => {
						return (
							<div>
								<div className="row">
									<div className="col-3">
										<Field
											canUpdate={values.type}
											component={Fields.AsyncSelectS1}
											type="text"
											name={"product_id"}
											label={tr("Товар")}
											placeholder={tr("Выберите")}
											loadOptionsUrl={"/products"}
											optionLabel={"name"}
											isSearchable={true}
											size={"small"}
											className={"mb-20"}
											loadOptionsParams={search => {
												return {
													filter: { type: values.type },
													extra: { _query: search },
													limit: 50,
													include: "unit,recipes.outputProduct.unit"
												};
											}}
										/>
									</div>
									<div className="col-3">
										<Field
											component={Fields.AsyncSelectS1}
											type="text"
											name={"storage_id"}
											label={tr("Склад для расхода")}
											placeholder={tr("Выберите склад")}
											loadOptionsUrl={"/storages"}
											optionLabel={"name"}
											isSearchable={true}
											size={"small"}
											className={"mb-20"}
											loadOptionsParams={search => {
												return {
													sort: "name"
												};
											}}
										/>
									</div>
									<div className="col-3">
										<Field
											component={Fields.AsyncSelectS1}
											type="text"
											name={"ref_product_storage_id"}
											label={tr("Склад для прихода")}
											placeholder={tr("Выберите склад")}
											loadOptionsUrl={"/storages"}
											optionLabel={"name"}
											isSearchable={true}
											size={"small"}
											className={"mb-20"}
											loadOptionsParams={search => {
												return {
													sort: "name"
												};
											}}
										/>
									</div>
									<div className="col-3">
										<div className="d-flex align-items-end">
											<Field
												component={Fields.InputS1}
												name="quantity"
												type="number"
												className={"mb-0"}
												placeholder={tr("Введите")}
												label={tr("Кол-во")}
												size={"small"}
												isRequired={true}
												prependData={
													<>
														<div className="form-field__prepend">
															{get(values, "product_id.unit.short_name")}
														</div>
													</>
												}
											/>
											<button
												disabled={!values.quantity || !values.product_id}
												type={"button"}
												className={`ml-10 d-btn d-btn--small fs-14 d-btn-primary`}
												onClick={e => {
													const productionQuantity =
														get(values, "product_id.production_quantity") || 1;

													const arr = get(
														values,
														"product_id.recipes",
														[]
													).reduce(
														(prev, curr) => [
															...prev,
															{
																product: curr.output_product,
																quantity: helpers.returnFloatWithFixedAndIntegerAsIs(
																	(Number(curr.quantity) *
																		Number(values.quantity)) /
																		productionQuantity
																)
															}
														],
														[]
													);
													setItems(arr);
												}}
											>
												{tr("Добавить")}
											</button>
										</div>
									</div>
								</div>

								{items.length > 0 && (
									<>
										<div className="default-table-wrap">
											<table className="default-table default-table-hover">
												<thead>
													<tr>
														<th className="w-50 text-cen">№</th>
														<th>{tr("Продукт")}</th>
														<th className="text-right">{tr("Кол-во")}</th>
														<th className="w-100"></th>
													</tr>
												</thead>
												<tbody>
													{items.map((item, ind) => {
														return (
															<tr>
																<td className="w-50 text-cen">{ind + 1}</td>
																<td>{get(item, "product.name")}</td>
																<td className="text-right">
																	{get(item, "quantity") +
																		" " +
																		get(item, "product.unit.short_name")}
																</td>
																<td className="w-100 pad-0">
																	<div className="d-flex justify-content-center">
																		<span
																			className="action-btn action-btn--danger"
																			onClick={() => deleteAction(item)}
																		>
																			<DeleteIcon />
																		</span>
																	</div>
																</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</div>
										<button
											disabled={isSubmitting}
											type={"button"}
											className={`${
												isSubmitting ? "--loading" : ""
											} w-100p justify-content-center mt-30 d-btn d-btn--small fs-14 d-btn-primary`}
											onClick={() => submitHandler(values)}
										>
											{tr("Создать расход")}
										</button>
									</>
								)}
							</div>
						);
					}}
				</EntityForm.Default>
			</div>
		</div>
	);
};

export default ConsumptionHFPModal;
